import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AutoSyncService {
  private readonly _isAutoPollingEnabled = signal<boolean>(false);

  // public read-only signal – expose this!
  readonly isAutoPollingEnabled = this._isAutoPollingEnabled.asReadonly();

  // Methods to modify the state
  setEnabled(value: boolean): void {
    this._isAutoPollingEnabled.set(value);
  }

  toggleEnabled(): void {
    this._isAutoPollingEnabled.update(current => !current);
  }
}
